export enum IAllowedSystemEnum {
  VeilingOnline = 1,
  Ecommerce = 3,
  UserManagement = 4,
  KoaStreaming = 5,
  Internal = 6,
  Customer = 7,
  RealPhotos = 9,
}

export default IAllowedSystemEnum;
